import React from 'react';
import searchParamsStringify from '@Utils/searchParamsStringify';
import UIBreadcrumbs from '@UI/Breadcrumbs';
import { useRouteMatch } from 'react-router-dom';
import { Helmet } from 'rnd-helmet';

const getScript = (breadcrumbItems) => {
  const breadcrumbListScript = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [],
  };
  breadcrumbItems.forEach((item, index) => {
    breadcrumbListScript.itemListElement.push({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': `${process.env.REACT_APP_BASE_URL}${item.url}`, name: item.name,
      },
    });
  });
  return (
    <script type="application/ld+json">
      {JSON.stringify(breadcrumbListScript)}
    </script>
  );
};

function Breadcrumbs({
  breadcrumbs, currentRoute, searchParams, pageType,
}) {
  const breadcrumbItemsScript = [];

  // Add item for script.
  const addItem = (url, name) => {
    breadcrumbItemsScript.push({ url, name });
  };

  const baseUrl = currentRoute && currentRoute.path ? currentRoute.path.replace(':searchParams*', '') : null;
  let breadcrumbList = [];
  const route = useRouteMatch();
  if (breadcrumbs && breadcrumbs.items !== undefined) {
    breadcrumbs.items.forEach((breadcrumb) => {
      if (breadcrumb.link !== null) {
        breadcrumbList.push({
          title: breadcrumb.title,
          url: breadcrumb.link,
        });
        addItem(breadcrumb.link, breadcrumb.title);
      } else {
        breadcrumbList.push({
          title: breadcrumb.title,
        });
        addItem(route.url, breadcrumb.title);
      }
    });
  } else {
    return null;
  }
  const breadcrumbItems = {
    categories: {
      nullValues: [
        'page',
        'query',
      ],
    },
    tags: {
      nullValues: [
        'page',
        'query',
      ],
    },
  };
  if (searchParams && searchParams.facets) {
    Object.keys(searchParams.facets).forEach((facetType) => {
      const facets = searchParams.facets[facetType];
      let count = 0;
      let facetBreadcrumbs = [];
      Object.keys(facets).forEach((facet) => {
        if (facets[facet].checked && count < 1) {
          const facetBuilder = { facets: {} };
          facetBuilder.facets[facetType] = { ...facets };
          breadcrumbItems[facetType].nullValues.forEach((facetName) => {
            facetBuilder[facetName] = null;
          });
          const url = `${baseUrl}${searchParamsStringify(pageType, facetBuilder)}`;

          facetBreadcrumbs.push({
            title: facets[facet].name,
            url,
          });
          count = +1;
        } else if (facets[facet].checked && count >= 1) {
          facetBreadcrumbs = [];
        }
      });
      breadcrumbList = [...breadcrumbList, ...facetBreadcrumbs];
      facetBreadcrumbs.forEach((item) => {
        addItem(item.url, item.name);
      });
    });
  }

  // Highlight the last item.
  if (breadcrumbList.length > 1 && breadcrumbList[breadcrumbList.length - 1]) {
    breadcrumbList[breadcrumbList.length - 1].active = true;
  }

  // Setup mobile item.
  let mobileItem = breadcrumbList[breadcrumbList.length - 1];
  if (breadcrumbList.length > 1) {
    mobileItem = breadcrumbList[breadcrumbList.length - 2];
  }

  return (
    <>
      <Helmet>
        {getScript(breadcrumbItemsScript)}
      </Helmet>

      <UIBreadcrumbs items={breadcrumbList} mobileItem={mobileItem} />
    </>
  );
}

export default Breadcrumbs;
